import { IssueViewModel } from "./issue.viewModel";

export class PubIssuesRecordViewModel {
	readonly pubId: string;
	readonly pubName: string;
	numberOfSelectedDates: number = 0;
	readonly issues: IssueViewModel[] = [];

	constructor (pubId: string, pubName: string) {
		this.pubId = pubId;
		this.pubName = pubName;
	}

}
